import { SwatchBook } from 'lucide-react';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { cn } from 'components/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

export const BrandKitController: React.FC = () => {
  const { isBrandKitOpen, setIsBrandKitOpen } = useTemplateStudioState();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={cn(
            'w-9 h-9 flex justify-center items-center cursor-pointer hover:bg-neutral-100 rounded-md',
            isBrandKitOpen
              ? 'text-indigo-500 bg-neutral-100'
              : 'text-base-sidebarRing'
          )}
          onClick={() => setIsBrandKitOpen(!isBrandKitOpen)}
        >
          <SwatchBook size={16} />
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="bg-[#71717A] text-white text-xs px-2 py-1 rounded-md">
          Brand Kit
        </p>
      </TooltipContent>
    </Tooltip>
  );
};
